import { Button } from '@fabric-app/ui/components/Button';
import { styled } from 'styled-components';

const SummarizeInlineButton = styled(Button).attrs((p) => {
  return {
    size: "xs",
    ...p,
    children: "Summarize"
  };
}).withConfig({
  displayName: "SummarizeInlineButton",
  componentId: "sc-87eb69d2-0"
})([
  `background:linear-gradient(124deg,#000000 9.53%,#8118d3 86.22%);color:white;font-size:14px;font-weight:500;padding:5.5px 8px;border-radius:6px;`
]);

export { SummarizeInlineButton };
//# sourceMappingURL=SummarizeInlineButton.js.map
